import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  BricksModalBodyComponent,
  BricksModalComponent,
  BricksModalFooterComponent,
  BricksModalHeaderComponent,
} from '@enbw_bricks/ui'

@Component({
  selector: 'app-direct-marketing-tooltip-content',
  templateUrl: './direct-marketing-tooltip-content.component.html',
  styleUrls: ['./direct-marketing-tooltip-content.component.scss'],
  imports: [BricksModalComponent, BricksModalHeaderComponent, BricksModalBodyComponent, BricksModalFooterComponent],
})
export class DirectMarketingTooltipContentComponent {
  matDialogRef = inject<MatDialogRef<DirectMarketingTooltipContentComponent>>(MatDialogRef)
  data = inject(MAT_DIALOG_DATA)

  closeDialog() {
    this.matDialogRef.close()
  }
}
